import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import './EventsPage.css';

const fmtDate = d => d ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

const EventsPage = () => {
    const [site, setSite] = useState(null);
    const [eventsMeta, setEventsMeta] = useState(null);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/content/site'),
            api.get('/content/events'),
            api.get('/events'),
        ])
            .then(([siteRes, metaRes, eventsRes]) => {
                setSite(siteRes.data);
                setEventsMeta(metaRes.data);
                setEvents(eventsRes.data || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error loading events:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!site) {
        return (
            <div className="error-screen">
                <h1>Error loading content</h1>
                <p>Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="App">
            <MetaTags
                title="Events | Melbourne Nepalese Community West"
                description="Discover upcoming and past events organized by Melbourne Nepalese Community West (MNCW) - cultural celebrations, community gatherings, and social activities."
                url="https://mncw.org.au/events"
                image="https://mncw.org.au/assets/img/logo.jpg"
                type="website"
            />
            <Header data={site} />
            <div className="events-page-container">
                <div className="container">
                    <div className="page-header">
                        <h1>{eventsMeta?.title}</h1>
                        <p className="page-intro">{eventsMeta?.intro}</p>
                    </div>

                    <div className="events-grid">
                        {events.map((event) => (
                            <div
                                key={event.slug || event.id}
                                className={`event-card ${event.status === 'past' ? 'past-event' : ''}`}
                            >
                                <div className="event-image">
                                    {event.image_url && <img src={event.image_url} alt={event.title} />}
                                    <div className="event-status-badge">
                                        {event.status === 'upcoming' ? (
                                            <span className="upcoming">Upcoming</span>
                                        ) : (
                                            <span className="past">Past Event</span>
                                        )}
                                    </div>
                                </div>
                                <div className="event-content">
                                    <h3>{event.title}</h3>
                                    <div className="event-details">
                                        <div className="event-detail">
                                            <i className="fas fa-calendar"></i>
                                            <span>{fmtDate(event.event_date)}</span>
                                        </div>
                                        {event.venue && (
                                            <div className="event-detail">
                                                <i className="fas fa-map-marker-alt"></i>
                                                <span>{event.venue}</span>
                                            </div>
                                        )}
                                    </div>
                                    {event.description && (
                                        event.description.includes('<')
                                            ? <div dangerouslySetInnerHTML={{ __html: event.description.replace(/<[^>]+>/g, ' ').substring(0, 180) + '…' }} />
                                            : <p>{event.description.substring(0, 180)}{event.description.length > 180 ? '…' : ''}</p>
                                    )}
                                    <Link to={`/events/${event.slug || event.id}`} className="event-link">
                                        View Details <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer data={site} />
        </div>
    );
};

export default EventsPage;
